import { render, staticRenderFns } from "./LayoutPattern.vue?vue&type=template&id=3c731cfe&"
import script from "./LayoutPattern.vue?vue&type=script&lang=js&"
export * from "./LayoutPattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports